import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { TranslateService } from "@ngx-translate/core";
import { DialogService } from "primeng/dynamicdialog";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from '@medsurf/flat-validators';
import { ModalControlComponent } from "@medsurf/flat-components";

@Component({
    selector: 'medsurf-quiz-mapping-question-solution',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './mapping-question-solution.component.html',
    styleUrls: ['./mapping-question-solution.component.scss'],
    standalone: false
})
export class MappingQuestionSolutionComponent {
  @Input({required: true}) set index(value: number) {
    this.#index = value;
    this.updateForm();
  }
  get index() {
    return this.#index;
  }
  @Input({required: true}) set question(value: FlatModels.QuestionEntityModels.MappingQuestion) {
    this.#question = structuredClone(value);
    this.updateForm();
  }
  get question() {
    return this.#question;
  }
  @Input({required: true}) set choices(value: FlatModels.ChoiceEntityModels.Choice[]) {
    this.#choices = structuredClone(value);
    this.updateForm();
  }
  get choices() {
    return this.#choices;
  }
  @Output() solutionChange = new EventEmitter<{index: number, value: string}>();
  
  #index: number
  #question: FlatModels.QuestionEntityModels.MappingQuestion;
  #choices: FlatModels.ChoiceEntityModels.Choice[];
  form = new FormGroup(
    {
      solution: new FormControl(0),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.QuestionEntityModels.MappingQuestionSolutionSchema
      ),
      updateOn: 'change'
    }
  );
  readonly FlatModels = FlatModels;

  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public dialogService: DialogService,
              public translate: TranslateService) {
  }
  
  updateForm() {
    if (this.#index !== undefined && this.question && this.choices) {
      if (this.form && this.form.value.solution !== Number.parseInt(this.question.solutions[this.index])) {
        // Update Data
        this.form.reset({ solution: Number.parseInt(this.question.solutions[this.index]) });
      }
    }
  }

  onChange() {
    this.solutionChange.emit({index: this.index, value: this.form.value.solution?.toString() || '0'});
  }

  removeSolution() {
    const dialogRef = this.dialogService.open(ModalControlComponent, {
      header: this.translate.instant('global.solution_remove'),
      data: {
        label: 'global.solution_remove_confirm',
        inputLabel: 'global.remove',
        inputClass: FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER
      },
      dismissableMask: true,
      width: '50%'
    });
    dialogRef.onClose.subscribe(remove => {
      if (remove) {
        // Remove Choice
        this.slideAuthorFacade.requestRemoveMappingQuestionSolution(this.question, this.index, 'history.solution_remove').subscribe({
          error: (result) => this.alertControlFacade.requestAddError(result),
        });
      }
    });
  }
}
